import { CashbackIcon, cashbackIcon, discountIcon, experienceIcon, giftCardIcon, membershipIcon, Subscription } from "../assets/svg/index.js";

import { GoSun } from "react-icons/go";
import { IoPartlySunnyOutline } from "react-icons/io5";
import { PiCloudMoon, PiCloudSun } from "react-icons/pi";

import CommerceSection from "../Components/HomePage/Section/CommerceSection.js";
import ExperienceSection from "../Components/HomePage/Section/ExperienceSection.js";
import LoyalitySection from "../Components/HomePage/Section/LoyalitySection.js";
import MembershipSection from "../Components/HomePage/Section/MembershipSection.js";
import RewardSection from "../Components/HomePage/Section/RewardSection.js";
import SubscriptionSection from "../Components/HomePage/Section/SubscriptionSection.js";
import TravelSection from "../Components/HomePage/Section/TravelSection.js";
import { COMMERCE_MODULE, EXPERIENCE_MODULE, REWARD_LISTING, SUBSCRIPTION_LISTING, TRAVEL_MODULE, VIP_MODULE } from "../Routes/RoutesContant.js";

export const TABMAPPING = {
  merchant_funded_offers: { title: "Discount Offers", Icon: discountIcon },
  affiliate_cashback: { title: "Cashback", Icon: cashbackIcon },
  gift_card: { title: "Gift Cards", Icon: giftCardIcon },
  access_n_membership: { title: "Access & Membership", Icon: membershipIcon },
  experiences: { title: "Experiences", Icon: experienceIcon },
};

export const CATEGORYMAPPING = {
  Country: "countries",
  Categories: "brand_categories",
  "Event & Occasion": "events",
  Retailers: "brands",
  "Spend Type": "offer_categories",
};

// constant for offer_type 
export const cardTitleToPath = (cardTitle) => {
  const pathMapping = {
    gift_card: "giftcard",
    affiliate_cashback: "cashback",
    merchant_funded_offers: "discount",
    access_n_membership: "membership",
    experiences: "experience",
  };
  return pathMapping[cardTitle] || "/";
};

export const getOfferType = (key) => {
  const OfferType = {
    merchant_funded_offers: "Discount Offers",
    affiliate_cashback: "Cashback",
    gift_card: "Gift Cards",
    access_n_membership: "Access & Membership",
    experiences: "Experiences"
  };
  return OfferType[key] || null;
};

export const getOfferTypeResultAPI = (key) => {
  const OfferType = {
    "discount": "merchant_funded_offers",
    "cashback": "affiliate_cashback",
    "giftcard": "gift_card",
    "membership": "access_n_membership",
    "experience": "experiences",
  };
  return OfferType[key] || null;
};

const IST_OFFSET = 330;
const DATE_FORMAT = 'YYYY-MM-DD';
const DISPLAY_DATE_FORMAT = 'ddd, DD MMM';

export { DATE_FORMAT, DISPLAY_DATE_FORMAT, IST_OFFSET };

// Data structure for the different offer types
const OfferTypes = {
  gift_card: {
    title: "Gift Cards",
    Icon: giftCardIcon,
    key: "gift_card",
    name: "Gift Card"
  },
  merchant_funded_offers: {
    title: "Discount Offers",
    Icon: discountIcon,
    key: "merchant_funded_offers",
    name: "Discount Offer"
  },
  affiliate_cashback: {
    title: "Cashback",
    Icon: cashbackIcon,
    key: "affiliate_cashback",
    name: "Cashback"
  },
  access_n_membership: {
    title: "Access & Membership",
    Icon: membershipIcon,
    key: "access_n_membership",
    name: "Access & Membership"
  },
  experiences: {
    title: "Experiences",
    Icon: experienceIcon,
    key: "experiences",
    name: "Experience",
  },
};

// Function to get offer type based on the key
export const getOfferTypeResult = (key) => {
  // Return the object with title, icon, and key based on the key provided
  return OfferTypes[key] || null;
};

export const EmptyMessagemap = {
  all_rewards: "No rewards found.",
  gift_card: "No gift card offers found.",
  merchant_funded_offers: "No discount offers found.",
  affiliate_cashback: "No cashback offers found.",
  access_n_membership: "No Access and membership rewards found.",
  experiences: "No experiences found.",
};

// Module tab section 
// to show or hide module tabs you just comment or uncomment the MODULETABS array 
// temperory we are showing only reward module in production|
export const MODULETABS = [
  { id: "reward", title: "Rewards", path: REWARD_LISTING, icon: CashbackIcon },
  // { id: "subscription", title: "Subscription", path: SUBSCRIPTION_LISTING, icon: Subscription },
  // { id: "travel", title: "Travel", path: TRAVEL_MODULE, icon: Subscription },
  // { id: "commerce", title: "Commerce", path: COMMERCE_MODULE, icon: Subscription },
  // { id: "membership", title: "VIP", path: VIP_MODULE, icon: Subscription },
  // { id: "experience", title: "Experience", path: EXPERIENCE_MODULE, icon: Subscription },
];

// function to render module 
// to show or hide the module in the homepage we just comment the module name in the moduleMapping object
// temperory we are showing only reward module in production|
export const moduleMapping = {
  reward: RewardSection,
  // travel: TravelSection,
  // subscription: SubscriptionSection,
  // commerce: CommerceSection,
  // loyality: LoyalitySection,
  // membership: MembershipSection,
  // experience: ExperienceSection
};

export const MODULE_TYPES = {
  SUBSCRIPTION: 'subscription',
  TRAVEL: 'travel',
  REWARD: 'reward',
  LOYALITY: 'loyality',
  MEMBERSHIP: 'membership',
  EXPERIENCE: 'experience',
  COMMERCE: 'commerce'
};

export const FLIGHT_CLASS_CONSTANT = {
  ECONOMY: 'ECONOMY',
  PREMIUM_ECONOMY: 'PREMIUM_ECONOMY',
  FIRST: 'FIRST',
  BUSINESS: 'BUSINESS',
}

export const FLIGHT_CLASS = [
  { value: FLIGHT_CLASS_CONSTANT.ECONOMY, label: 'Economy' },
  { value: FLIGHT_CLASS_CONSTANT.PREMIUM_ECONOMY, label: 'Premium Economy' },
  { value: FLIGHT_CLASS_CONSTANT.FIRST, label: 'First Class' },
  { value: FLIGHT_CLASS_CONSTANT.BUSINESS, label: 'Business' },
]

export const FLIGHT_TRIP_CONSTANT = {
  ONEWAY: 'ONEWAY',
  ROUNDTRIP: 'ROUNDTRIP',
  MULTICITY: 'MULTICITY',
}

export const FLIGHT_TRIP_CATEGORIES = [
  { value: FLIGHT_TRIP_CONSTANT.ONEWAY, label: 'One Way' },
  { value: FLIGHT_TRIP_CONSTANT.ROUNDTRIP, label: 'Round Trip' },
  { value: FLIGHT_TRIP_CONSTANT.MULTICITY, label: 'Multi City' },
]

export const AIRPORTS = [
  { iata_code: "DEL", name: "Indira Gandhi International Airport", city: "New Delhi", state: "Delhi", country: "India" },
  { iata_code: 'BOM', name: 'Chhatrapati Shivaji International Airport', city: 'Mumbai', state: "Maharashtra", country: "India" },
  { iata_code: 'BLR', name: 'Kempegowda International Airport', city: 'Bengaluru', state: "Karnataka", country: "India" },
  { iata_code: 'MAA', name: 'Chennai International Airport', city: 'Chennai', state: "Tamil Nadu", country: "India" },
  { iata_code: 'CCU', name: 'Netaji Subhas Chandra Bose International Airport', city: 'Kolkata', state: "West bengal", country: "India" }
];

export const DEFAULT_TRAVEL_COUNT = {
  adults: 1,
  children: 0,
  infants: 0
}

export const TRAVELLER_DEFAULT_MAP = [
  { type: 'adults', label: 'Adults', age: '(12+ Years)', min: 1, max: 9 },
  { type: 'children', label: 'Children', age: '(2-12 Years)', min: 0, max: 9 },
  { type: 'infants', label: 'Infant', age: '(0-2 Years)', min: 0, max: 9 }
];

export const TIMESLOTS = [
  { label: 'Before 6 AM', value: "00:00-06:00", Logo: PiCloudSun },
  { label: '6 AM - 12 PM', value: '06:00-12:00', Logo: GoSun },
  { label: '12 PM - 6 PM', value: '12:00-18:00', Logo: IoPartlySunnyOutline },
  { label: 'After 6 PM', value: '18:00-24:00', Logo: PiCloudMoon },
];

export const STOPS = {
  oneStop: "One Stop",
  nonStop: "Non Stop",
  twoPlusStops: "2+ Stops"
};

export const FLIGHT_IMAGE_URL = (airlineCode) => `https://flight.easemytrip.com/Content/AirlineLogon/${airlineCode}.png`;